const en = {
  // Nav
  nav_home: "Home",
  nav_services: "Services",
  nav_about: "About",
  nav_pricing: "Pricing",
  nav_reviews: "Reviews",
  nav_faq: "FAQ",
  nav_contact: "Contact",
  nav_cta: "Get Free Quote",

  // Hero
  hero_badge: "TRUSTED BY 500+ CLIENTS",
  hero_headline: "Professional Cleaning Services You Can Trust",
  hero_subheadline: "Residential and commercial cleaning with premium quality results. Insured, reliable, and always on time.",
  hero_cta_primary: "Get Free Quote",
  hero_cta_secondary: "Book Now",
  hero_trust_1: "100% Satisfaction",
  hero_trust_2: "Fully Insured",
  hero_trust_3: "5-Star Rated",
  hero_rating: "4.9/5 from 247+ reviews",

  // Services Preview
  services_label: "OUR SERVICES",
  services_headline: "Complete Cleaning Solutions",
  services_sub: "From cozy homes to large commercial spaces, we deliver spotless results every time.",
  services_learn_more: "Learn More",
  service_residential: "Residential Cleaning",
  service_residential_desc: "Thorough, top-to-bottom cleaning for your home using eco-friendly products.",
  service_commercial: "Commercial Cleaning",
  service_commercial_desc: "Professional office and commercial space cleaning that keeps your business shining.",
  service_deep: "Deep Cleaning",
  service_deep_desc: "Intensive cleaning reaching every corner — perfect for seasonal or first-time cleans.",
  service_moveinout: "Move In / Move Out",
  service_moveinout_desc: "Make your move stress-free with our comprehensive move-in and move-out cleaning.",
  service_airbnb: "Airbnb Cleaning",
  service_airbnb_desc: "Fast, reliable turnovers that keep your guests happy and your ratings high.",
  service_office: "Office Cleaning",
  service_office_desc: "A clean office boosts productivity. We handle it so your team can focus on work.",

  // Benefits
  benefits_label: "WHY CHOOSE US",
  benefits_headline: "Premium Quality, Every Time",
  benefits_text: "We combine professional expertise with genuine care for your home and business. Our team is background-checked, trained, and fully insured so you can relax.",
  benefits_cta: "Get Started",
  benefit_reliable: "Reliable Team",
  benefit_reliable_desc: "Background-checked, trained professionals who show up on time, every time.",
  benefit_eco: "Eco-Friendly Products",
  benefit_eco_desc: "We use safe, high-quality products that protect your family, pets, and the environment.",
  benefit_flexible: "Flexible Scheduling",
  benefit_flexible_desc: "Book at your convenience — mornings, evenings, weekends. We adapt to your schedule.",
  benefit_affordable: "Affordable Pricing",
  benefit_affordable_desc: "Transparent, competitive pricing with no hidden fees. Premium service at fair rates.",
  benefit_guaranteed: "Satisfaction Guaranteed",
  benefit_guaranteed_desc: "Not happy? We'll come back and re-clean at no charge. Your satisfaction is our promise.",
  benefit_insured: "Fully Insured",
  benefit_insured_desc: "Complete peace of mind — we are fully licensed, bonded, and insured for your protection.",

  // Process
  process_label: "HOW IT WORKS",
  process_headline: "Simple Booking Process",
  process_sub: "Get your space professionally cleaned in three easy steps.",
  process_step1_title: "Request a Quote",
  process_step1_desc: "Fill out our quick form and we'll get back to you with a personalized quote within hours.",
  process_step2_title: "Schedule Service",
  process_step2_desc: "Pick a date and time that works for you. We'll confirm and send reminders.",
  process_step3_title: "Enjoy a Spotless Space",
  process_step3_desc: "Our team arrives on time, cleans thoroughly, and leaves your space immaculate.",
  process_cta: "Book Your Service Now",

  // Stats
  stat_clients: "Happy Clients",
  stat_years: "Years Experience",
  stat_satisfaction: "Satisfaction Rate",
  stat_support: "Support Available",

  // Testimonials
  testimonials_label: "CLIENT REVIEWS",
  testimonials_headline: "What Our Clients Say",
  testimonials_sub: "Real reviews from real people who trust Prime Shine WA.",

  // CTA Section
  cta_headline: "Ready for a Spotless Space?",
  cta_sub: "Book your professional cleaning service today. No commitment required.",
  cta_primary: "Get Free Quote",
  cta_secondary: "Call Now",
  cta_note: "No commitment required • Free consultation",

  // Pricing
  pricing_label: "PRICING",
  pricing_headline: "Simple, Transparent Pricing",
  pricing_sub: "No hidden fees. Choose the plan that fits your needs or request a custom quote.",
  pricing_popular: "Most Popular",
  pricing_cta: "Get Started",
  pricing_custom_cta: "Request Custom Quote",
  pricing_custom_headline: "Need something specific?",
  pricing_custom_text: "Commercial spaces, large homes, or recurring services — we offer custom quotes tailored to your exact needs.",

  // FAQ
  faq_label: "FAQ",
  faq_headline: "Frequently Asked Questions",
  faq_sub: "Everything you need to know about our cleaning services.",

  // Contact
  contact_label: "CONTACT US",
  contact_headline: "Let's Get Started",
  contact_sub: "Ready for a cleaner space? Reach out and we'll get back to you within a few hours.",
  contact_name: "Full Name",
  contact_email: "Email Address",
  contact_phone: "Phone Number",
  contact_service: "Service Type",
  contact_message: "Message",
  contact_submit: "Send Message",
  contact_submitting: "Sending...",
  contact_success: "Message sent! We'll be in touch shortly.",
  contact_whatsapp: "Chat on WhatsApp",
  contact_area: "Service Area",
  contact_area_value: "Greater Seattle Area, WA",
  contact_hours: "Mon–Fri: 8am–6pm | Sat: 9am–4pm",

  // Footer
  footer_desc: "Premium professional cleaning services for homes, offices, and short-term rentals across Washington State.",
  footer_quick_links: "Quick Links",
  footer_services: "Services",
  footer_contact: "Get In Touch",
  footer_newsletter: "Stay Updated",
  footer_newsletter_placeholder: "Your email address",
  footer_newsletter_cta: "Subscribe",
  footer_copyright: "© 2026 Prime Shine WA. All rights reserved.",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Service",

  // About
  about_label: "ABOUT US",
  about_headline: "Your Trusted Cleaning Partner",
  about_story_label: "OUR STORY",
  about_story_headline: "Born From a Passion for Cleanliness",
  about_mission_label: "MISSION",
  about_mission_headline: "Our Mission",
  about_vision_label: "VISION",
  about_vision_headline: "Our Vision",
  about_values_label: "OUR VALUES",
  about_values_headline: "What Drives Us",
  about_why_label: "WHY CHOOSE US",
  about_why_headline: "The Prime Shine Difference",
  about_team_label: "OUR TEAM",
  about_team_headline: "Meet the Professionals",
};

export default en;
